import {
  FETCH_HOMEPAGE,
  FETCH_HOMEPAGE_FULFILLED,
  FETCH_HOMEPAGE_REJECTED,
} from 'b2b-apps/shop/content/redux/homepage/actionTypes';
import {
  FetchHomepageAction,
  FetchHomepageFulfilledAction,
  FetchHomepageRejectedAction,
  HomepageType,
} from 'b2b-apps/shop/content/redux/homepage/types';

const fetchHomepage = (): FetchHomepageAction => ({
  type: FETCH_HOMEPAGE,
});

const fetchHomepageFulfilled = (data: HomepageType): FetchHomepageFulfilledAction => ({
  type: FETCH_HOMEPAGE_FULFILLED,
  payload: { data },
});

const fetchHomepageRejected = (error: ErrorType): FetchHomepageRejectedAction => ({
  type: FETCH_HOMEPAGE_REJECTED,
  payload: { error },
});

export { fetchHomepage, fetchHomepageFulfilled, fetchHomepageRejected };
